import React, { Fragment, useState } from 'react';
import EditIcon from '@mui/icons-material/Edit';
import { Button, Card, CardContent, Grid, IconButton } from '@mui/material';
import SelectButtonGroup from '../../../../../components/SelectButtonGroup/SelectButtonGroup';
import EditDisplayNamesDialog from '../../../../../components/EditDisplayNamesDialog/EditDisplayNamesDialog';
import './CalculatorProfiles.scss';
import SwiperCore, { Pagination } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import { getPremiumFinancingProfileDisplay } from '../../../../../utils/premium-financing';

SwiperCore.use([Pagination]);

const VersionButtons = ({ index, intl, versionChoices, onChange }) => {
  return (
    <SelectButtonGroup
      value={index}
      choices={versionChoices}
      buttonClassName="profile-buttons"
      spacing={2}
      onChange={onChange}
      sx={{ justifyContent: "center" }}
    />
  );
};

const CalculatorProfiles = props => {
  const {
    pFinProfiles,
    index,
    onIndexChange,
    openEditDisplayNamesDialog,
    saveProfiles,
    intl,
    isSmallScreen,
    extraSideInputs
  } = props;

  const getVersionChoices = indexes =>
    indexes.map(index => {
      return {
        label: getPremiumFinancingProfileDisplay(intl, pFinProfiles[index], index),
        value: index,
        xs: 6
      };
    });

  // 2x2 grid per page — pagination dots grow with profile count
  const VERSION_PAGE_SIZE = 4;
  const versionPages = [];
  for (let start = 0; start < (pFinProfiles || []).length; start += VERSION_PAGE_SIZE) {
    const indexes = [];
    for (let i = start; i < Math.min(start + VERSION_PAGE_SIZE, pFinProfiles.length); i += 1) {
      indexes.push(i);
    }
    versionPages.push(getVersionChoices(indexes));
  }

  return (
    <Fragment>
      <Card className="pfa-card pf-card-container calculator-profiles">
        <CardContent>
          <Grid container>
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                width: '100%',
                marginBottom: 12
              }}
            >
              <div style={{ flex: 1 }} />
              <div style={{ display: 'flex', justifyContent: 'center', flex: 1 }}>
                <div className="custom-swiper-pagination" />
              </div>
              <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', flex: 1 }}>
                <IconButton
                  className="editIconButton"
                  onClick={openEditDisplayNamesDialog}
                  size="small"
                  style={{ padding: 0 }}
                >
                  <EditIcon style={{ fontSize: 16 }} />
                </IconButton>
              </div>
            </div>
            <Grid size={12} style={{ paddingTop: 0 }}>
              <div>
                <Swiper
                  spaceBetween={15}
                  centeredSlides={true}
                  centeredSlidesBounds={true}
                  autoHeight={true}
                  initialSlide={0}
                  slidesPerView={1}
                  navigation={false}
                  pagination={{
                    el: '.custom-swiper-pagination',
                    clickable: true
                  }}
                >
                  {versionPages.map((versionChoices, pageIndex) => (
                    <SwiperSlide key={pageIndex}>
                      <VersionButtons
                        intl={intl}
                        index={index}
                        versionChoices={versionChoices}
                        onChange={onIndexChange}
                        isSmallScreen={isSmallScreen}
                      />
                    </SwiperSlide>
                  ))}
                </Swiper>
              </div>
            </Grid>
            <Grid size={12} className="save-button">
              <Button onClick={saveProfiles} color="primary" variant="contained">
                {intl.formatMessage({ id: 'save-data' })}
              </Button>
            </Grid>
          </Grid>
          {extraSideInputs && extraSideInputs}
        </CardContent>
      </Card>
    </Fragment>
  );
};

export default CalculatorProfiles;
